// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3kuC4","emails":"CreateEditClinics_emails__1zNLW","emailTagLabel":"CreateEditClinics_emailTagLabel__20_or"};